import { useEffect } from 'react';

import { OrderExecutionTermsOperationKind } from 'api/types/entity/order/orderExecutionTermsEntity';
import { useField } from 'modules/order/common/forms/orderForm';

export const useConfirmationDocumentSection = () => {
  const { field: operationKindField } = useField(
    'executionTerms.operationKind'
  );

  const { helpers: contractDateFieldHelpers } = useField(
    'confirmationDocument.contractDate'
  );
  const { helpers: contractNumberFieldHelpers } = useField(
    'confirmationDocument.contractNumber'
  );

  const isDisabledField =
    !operationKindField?.value?.value ||
    operationKindField?.value?.value ===
      OrderExecutionTermsOperationKind.ChangeNominalHolder;

  const isRequiredField =
    operationKindField?.value?.value ===
      OrderExecutionTermsOperationKind.DeliveryFreeOfPayment ||
    operationKindField?.value?.value ===
      OrderExecutionTermsOperationKind.DeliveryVersusPayment;

  useEffect(() => {
    if (isDisabledField) {
      contractDateFieldHelpers.setValue(null);
      contractDateFieldHelpers.setError(undefined);
      contractNumberFieldHelpers.setError(undefined);
      contractNumberFieldHelpers.setValue('');
    }
  }, [isDisabledField, contractDateFieldHelpers, contractNumberFieldHelpers]);
  return {
    isRequiredField,
    isDisabledField,
  };
};
